<template>
  <span
    class="mr-6 px-2 py-1 leading-none absolute rounded-full bg-gray-500 text-sm text-gray-900 font-semibold badge-centered"
  >
    <!-- bg-blue-400 text-gray-900 -->
    <!-- bg-blue-800 text-gray-200 -->
    <!-- bg-gray-500 text-gray-900 -->
    <!-- bg-red-800 text-gray-200 -->
    <slot />
  </span>
</template>

<script>
export default {
  name: 'Badge'
}
</script>

<style scoped>
.badge-centered {
  top: 50%;
  transform: translateY(-50%);
}
</style>
